module.exports = require("./dist/components/modal");
